import { sendWebsocketMessage } from '../../../../../App';


export function modifyOpenOrderQuantity(order, newQuantity) {
  const msg = {
    messageType: 'orderUpdate',
    orderInfo: {
      brokerage: order.brokerage,
      accountId: order.accountId,
      orderId: order.id,
      value: newQuantity,
      type: 'quantity'
    },
  };
  sendWebsocketMessage(msg);
}
